import { ref, toRefs, reactive, computed, watch } from 'vue';
import { defineStore } from 'pinia'

export const useAppErrorStore = defineStore('appErrors', () => {

  const errors = ref([])

  function handleApiErrorResponse(error) {
    // console.log('handleApiErrorResponse', error)
    const request  = error.request
    const response = error.response
    const item = {
      statusCode: error.status,
      method:     error.config?.method,
      baseURL:    response.baseURL,
      fullURL:    request.responseURL,
      path:       response.config?.url,
      title:      error.message,
      body:       response.data,
    }
    errors.value.push(item)
  }

  function reset() {
    errors.value = []
  }
  
  return {
    errors,
    handleApiErrorResponse,
    reset,
  }
},
{
  // App errors are not persisted in localStorage.
  persist: false,
})
